import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DeviceAdapter, Device } from 'src/app/models/device.model';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeviceInventoryService {
  
  private _controller = 'inventory';
  private _commonColdStoreController = 'common-coldstore';
  private _customersController = 'common-customer';
  private _profileController = 'common-profile';
  private _profileTypeController = 'common-profile-type';
  private _commonUserController = 'common-user';
  private _commodityController = 'common-commodity';

  constructor(private _http: HttpClient, private _adapter: DeviceAdapter) { }

  getAll(params: string = '', page: number = 0, size: number = 20): Observable<any> {
    const pageParams = `?page=${page}&size=${size}${params}`;
    return this._http.get<any>(`${this._controller}${pageParams}`).pipe(
      map(response => ({
        content: response.content.map((item: any) => this._adapter.adapt(item)),
        totalElements: response.totalElements,
        totalPages: response.totalPages,
        number: response.number,
        size: response.size,
        first: response.first,
        last: response.last
      }))
    );
  }

  getById(id: Number): Observable<Device> {
    return this._http.get<Device>(`${this._controller}/${id}`).pipe(
      map(item => this._adapter.adapt(item))
    );
  }

  save(device: Device): Observable<any> {
    const formattedDevice = this._adapter.reverseAdapt(device);
    return this._http.post(this._controller, formattedDevice);
  }

  delete(id: Number): Observable<Object> {
    return this._http.delete<Object>(`${this._controller}/${id}`);
  }

  search(params: string): Observable<Device[]> {
    return this._http.get<Device[]>(`${this._controller}/search${params}`).pipe(
      map(items => items.map(item => this._adapter.adapt(item)))
    );
  }

  bulkUpload(devices: Device[]): Observable<any> {
    const formattedDevices = devices.map(device => this._adapter.reverseAdapt(device));
    return this._http.post(`${this._controller}/bulk-upload`, formattedDevices);
  }

  getCustomers(env: string): Observable<any> {
    const params = new HttpParams()
      .set('env', env);
    return this._http.get<any>(`${this._customersController}/all-customers`, { params });
  }

  getUserDetailsByCustomer(customerId: number, env: string): Observable<any> {
    console.log("customerId being sent:", customerId);
    let p = 0;
    let l = 100;
    const params = new HttpParams()
      .set('env', env);
    return this._http.get<any>(`${this._commonUserController}?p=${p}&l=${l}&customer_id=${customerId}`, { params });
  }

  getProfilesByCustomer(customerId: number, env: string): Observable<any> {
    const params = new HttpParams()
      .set('env', env);

    return this._http.get<any>(`${this._profileController}/dd?customer_id=${customerId}`, { params });
  }

  getProfileTypesByCustomer(customerId: number, env: string): Observable<any> {
    const params = new HttpParams()
      .set('env', env);
    return this._http.get<any>(`${this._profileTypeController}/dd?customer_id=${customerId}`, { params });
  }

  getCommodities(env: string): Observable<any> {
     const params = new HttpParams()
      .set('env', env);
    return this._http.get<any>(`${this._commodityController}/dd`, { params });
  }

  downloadTemplate(): Observable<Blob> {
    return this._http.get(`${this._controller}/download-device-template`, { responseType: 'blob' });
  }

  saveColdStore(result: any, env: string): Observable<any> {
    const params = new HttpParams()
      .set('env', env);
    return this._http.post(`${this._commonColdStoreController}/associate-coldstore`, result, { params });
  }
  deployDevice(result: any, env: string): Observable<any> {
    const params = new HttpParams()
      .set('env', env);
    return this._http.post(`${this._commonColdStoreController}/deploy-coldstore`, result, { params });
  }
  
  deassociateColdStore(deviceId: string, env: string): Observable<any> {
    return this._http.delete(`${this._controller}/dissociate-coldstore/${deviceId}`);
  }
} 